async function asyncForEach(array, callback) {
  for (let index = 0; index < array.length; index++) {
    await callback(array[index], index, array);
  }
}

function formatCurrency(value) {
  value = value ? parseFloat(value) : 0;
  return Intl.NumberFormat("es-GT", {
    style: "currency",
    currency: "GTQ",
  }).format(value);
}

function checkAmount(value) {
  const regex = /^[1-9]\d*(((,\d{3}){1})?(\.\d{0,2})?)$/;
  if (!regex.test(value)) {
    return false;
  }
  return true;
}

async function loadCars(
  Vue,
  code = null,
  includeOthers = true,
  itemOrder = false
) {
  const params = itemOrder ? { order: "item" } : {};
  const cars = await Vue.axios.get(
    "/fts/cars" +
      (null === code ? "" : "/" + code + (includeOthers ? "/others" : "")),
    { params: params }
  );
  if (cars.data.refreshToken) {
    Vue.$store.dispatch("refreshToken", cars.data.refreshToken);
  }

  if (itemOrder) {
    return await associateCarsItems(cars.data.data);
  }

  return cars.data.data;
}

async function associateCarsItems(cars) {
  let assocCars = [];
  await asyncForEach(cars, async (car) => {
    assocCars[car.item] = car;
  });
  return assocCars;
}

async function loadProperties(Vue, carId = null) {
  const properties = await Vue.axios.get(
    "/fts/properties" + (null === carId ? "" : "/" + carId)
  );
  if (properties.data.refreshToken) {
    Vue.$store.dispatch("refreshToken", properties.data.refreshToken);
  }
  return properties.data.data;
}

async function placeBid(Vue, carCode, bid) {
  let res;
  try {
    res = await Vue.axios.put("/fts/cars/" + carCode, {
      bid: bid,
    });
    if (res.status !== 201) {
      return false;
    }
  } catch (err) {
    return false;
  }
  if (res.data.refreshToken) {
    Vue.$store.dispatch("refreshToken", res.data.refreshToken);
  }
  return true;
}

async function changeBidOnly(Vue, carCode, bid) {
  return await changeBid(Vue, carCode, bid, null);
}

async function changeBidAffiliateOnly(Vue, carCode, bidAffiliate) {
  return await changeBid(Vue, carCode, null, bidAffiliate);
}

async function changeBid(Vue, carCode, bid, bidAffiliate) {
  let res;
  let body = { loggedUser: Vue.$store.getters.loggedInMembership };
  if (bid !== null) {
    body["bid"] = bid;
  }
  if (bidAffiliate !== null) {
    body["affiliate_code"] = bidAffiliate;
  }
  try {
    res = await Vue.axios.patch("/fts/cars/" + carCode, body);
    if (res.status !== 201) {
      return false;
    }
  } catch (err) {
    return false;
  }
  if (res.data.refreshToken) {
    Vue.$store.dispatch("refreshToken", res.data.refreshToken);
  }
  return true;
}

async function auctionStart(Vue, id) {
  let res;
  try {
    res = await Vue.axios.post("/fts/cars/auction", {
      id: id,
    });
    if (res.status !== 201) {
      return false;
    }
  } catch (err) {
    return false;
  }
  if (res.data.refreshToken) {
    Vue.$store.dispatch("refreshToken", res.data.refreshToken);
  }
  return true;
}

function getCar(carId, allCars, properties, filteredCar = false) {
  let cars = allCars;

  if (!filteredCar) {
    cars = allCars.filter(function(car) {
      return car.id === carId;
    });

    if (cars.length === 0) {
      return null;
    }
  }

  let car = cars[0];

  car.all_pictures = [];

  if (car.pictures_main !== null) {
    car.all_pictures = car.all_pictures.concat(car.pictures_main);
  }

  if (car.pictures_normal !== null) {
    car.all_pictures = car.all_pictures.concat(car.pictures_normal);
  }

  const ccArray = properties.filter(function(property) {
    return property.id === "4c3b2594-804f-399a-f7e2-4ecbaecae98d";
  });
  car.cc = ccArray.length === 0 ? "" : ccArray[0].value;
  const fuelArray = properties.filter(function(property) {
    return property.id === "4829291a-9b5b-36f8-800b-4ecbaeaf3a3f";
  });
  car.fuel = fuelArray.length === 0 ? "" : fuelArray[0].value;
  const mileageArray = properties.filter(function(property) {
    return property.id === "56663d73-d9a8-ab74-29f1-4ecbae90ecce";
  });
  car.mileage = mileageArray.length === 0 ? "" : mileageArray[0].value;
  const cilindersArray = properties.filter(function(property) {
    return property.id === "3a4fffe8-2c5f-81a6-4dee-4ecbaec0f30e";
  });
  car.cilinders = cilindersArray.length === 0 ? "" : cilindersArray[0].value;
  const doorsArray = properties.filter(function(property) {
    return property.id === "4417dcaf-23ee-e0cf-5115-4ecbae66aea2";
  });
  car.doors = doorsArray.length === 0 ? "" : doorsArray[0].value;
  const keysArray = properties.filter(function(property) {
    return property.id === "152e11ca-84d3-5aa0-899f-4ecbae5acee9";
  });
  car.keys = keysArray.length === 0 ? "" : keysArray[0].value;
  const keysMotoArray = properties.filter(function(property) {
    return property.id === "acf5ce7a-c8b4-9b88-1990-4ee6adb8865b";
  });
  car.keysMoto = keysMotoArray.length === 0 ? "" : keysMotoArray[0].value;
  car.keys = car.keys !== "" ? car.keys : car.keysMoto;
  const sourceArray = properties.filter(function(property) {
    return property.id === "f2780e96-acf2-9727-a88b-4ecbaef32a3a";
  });
  car.source = sourceArray.length === 0 ? "" : sourceArray[0].value;
  const transmissionArray = properties.filter(function(property) {
    return property.id === "892fe4fb-f6fb-fed2-15f7-5e920d515906";
  });
  car.transmission =
    transmissionArray.length === 0 ? "" : transmissionArray[0].value;
  const detailsArray = properties.filter(function(property) {
    return property.id === "d1271e8d-80d8-fb18-34e2-4f2049bad8ed";
  });
  car.details = detailsArray.length === 0 ? "" : detailsArray[0].value;

  car.flags = {
    starts: car.flag_starts,
    walks: car.flag_walks,
    failure: car.flag_failure,
    warranty: car.flag_warranty,
    flooded: car.flag_flooded,
    normalUse: car.flag_normal_use,
    collision: car.flag_collision,
    spareParts: car.flag_spare_parts,
  };

  return car;
}

function connectWebSocket(token, Vue) {
  // Use the vue-native-websocket instead of creating a custom connection
  // The main.js already configures vue-native-websocket with store integration
  
  try {
    // Connect using the built-in vue-native-websocket method
    Vue.prototype.$connect();
    
    // Set up authentication when connected
    const waitForConnection = () => {
      if (Vue.prototype.$socket && Vue.prototype.$socket.readyState === WebSocket.OPEN) {
        // Send authentication token
        Vue.prototype.$socket.send(JSON.stringify({
          token: token,
        }));
        
        // Set up ping interval for keeping connection alive
        const pingInterval = setInterval(() => {
          if (!Vue.prototype.$socket || Vue.prototype.$socket.readyState !== WebSocket.OPEN) {
            clearInterval(pingInterval);
            return;
          }
          
          Vue.prototype.$socket.send(JSON.stringify({
            action: "ping",
          }));
        }, 60000);
      } else {
        // Wait a bit and try again
        setTimeout(waitForConnection, 100);
      }
    };
    
    waitForConnection();
    
  } catch (error) {
    console.error('Failed to connect WebSocket via store:', error);
  }
}

function disconnectWebSocket(Vue) {
  try {
    if (Vue.prototype.$socket && Vue.prototype.$socket.readyState === WebSocket.OPEN) {
      // Send logout/disconnect message to server before closing
      Vue.prototype.$socket.send(JSON.stringify({
        action: "logout"
      }));
    }
    
    // Disconnect using the built-in vue-native-websocket method
    Vue.prototype.$disconnect();
    
  } catch (error) {
    console.error('Failed to disconnect WebSocket:', error);
  }
}

export default {
  formatCurrency,
  checkAmount,
  loadCars,
  loadProperties,
  getCar,
  placeBid,
  connectWebSocket,
  auctionStart,
  asyncForEach,
  changeBidAffiliateOnly,
  changeBidOnly,
  disconnectWebSocket,
};
